module.exports = __webpack_public_path__ + "img/roof.6209f4e0.jpg";